module.exports = __webpack_public_path__ + "static/img/Aacteacher6.4cc6298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aacteacher6.png
// module id = VfZM
// module chunks = 1